import { Certificate, getOrganizationLogo } from '@revenuemarket/bank';
import { Tooltip } from '@revenuemarket/ui';
import Image from 'next/image';

interface Props {
  certificate: Certificate;
}

const CardListRenderer: React.FC<Props> = ({ certificate }) => {
  return (
    <div style={{ display: 'flex', gap: 8 }}>
      {certificate.organizationList
        .filter((org) => org.organizationType === 'CD')
        .map((org) => {
          return (
            <div key={`card-icon-${org.organizationCode}`}>
              <button
                style={{
                  backgroundColor: 'transparent',
                }}
                data-tip
                data-for={`certificate-card-${org.organizationCode}`}
              >
                <Image
                  key={org.id}
                  src={getOrganizationLogo(org.organizationCode)?.x2}
                  alt={org.organizationCode}
                  width={24}
                  height={32}
                />
              </button>
              <Tooltip
                id={`certificate-card-${org.organizationCode}`}
                effect="solid"
                place={'top'}
                padding="4px 8px"
              >
                {org.organizationName}
              </Tooltip>
            </div>
          );
        })}
    </div>
  );
};

export default CardListRenderer;
